export default "__VITE_ASSET__e59441e8__"